import React from 'react';

interface SegmentedToggleProps {
    value: string;
    options: { value: string; label: string; icon: React.ReactNode; activeColorClass?: string }[];
    onChange: (value: string) => void;
}

export const SegmentedToggle: React.FC<SegmentedToggleProps> = ({ value, options, onChange }) => (
    <div className="flex bg-mapper-gray-bg rounded-[11px] p-[3px] shrink-0">
        {options.map(opt => {
            const active = opt.value === value;
            return (
                <button
                    key={opt.value}
                    onClick={() => onChange(opt.value)}
                    className={`flex items-center gap-[7px] px-[15px] py-2 rounded-lg text-[13px] font-semibold ${
                        active ? `bg-mapper-white shadow-mapper-segmented ${opt.activeColorClass ?? 'text-mapper-teal-hover'}` : 'text-mapper-muted'
                    }`}
                >
                    {opt.icon}
                    {opt.label}
                </button>
            );
        })}
    </div>
);
